import { Pipe, PipeTransform } from '@angular/core';
import { TelephoneNumber } from '@models';

@Pipe({
  name: 'appFormatUserPhone',
  standalone: true,
})
export class FormatUserPhonePipe implements PipeTransform {
  transform(value: TelephoneNumber | undefined): string {
    if (!value) {
      return '';
    }
    const { areaCode, countryCode, phoneNumber, extensionNumber } = value;

    // Start with the country code
    let formattedNumber = countryCode ? `+${Number(countryCode) > 0 ? countryCode : ' '} ` : '';

    // Add the area code if present
    if (areaCode) {
      formattedNumber += `(${areaCode}) `;
    }

    // Format the phone number (split into 3-3-4 parts)
    if (phoneNumber) {
      const cleanedPhone = phoneNumber.replace(/\D/g, ''); // Remove non-numeric characters
      formattedNumber +=
        cleanedPhone.length === 10
          ? `${cleanedPhone.slice(0, 3)}-${cleanedPhone.slice(3, 6)}-${cleanedPhone.slice(6)}`
          : cleanedPhone;
    } else {
      return '';
    }

    // Add the extension if present
    if (extensionNumber) {
      formattedNumber += ` ext. ${extensionNumber}`;
    }

    return formattedNumber.trim();
  }
}
